// extracted by mini-css-extract-plugin
module.exports = {"container":"investment-dashboard_container__2uwOi","sep":"investment-dashboard_sep__2Gq1y"};